function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "m16.25 15.167c-2.925 0-8.6667 1.4083-8.6667 4.3333v2.1667h17.333v-2.1667c0-2.925-5.7416-4.3333-8.6666-4.3333zm0-2.1667c1.1492 0 2.2514-0.4565 3.0641-1.2692 0.8126-0.8126 1.2692-1.9148 1.2692-3.0641s-0.4566-2.2515-1.2692-3.0641c-0.8127-0.81266-1.9149-1.2692-3.0641-1.2692-1.1493 0-2.2515 0.45655-3.0642 1.2692-0.8126 0.81266-1.2692 1.9149-1.2692 3.0641s0.4566 2.2515 1.2692 3.0641c0.8127 0.8127 1.9149 1.2692 3.0642 1.2692zm-10.833 3.25-0.65-0.5416c-2.1667-2.0584-3.6833-3.3584-3.6833-4.9834 0-1.3 1.0833-2.3833 2.3833-2.3833 0.75833 0 1.5167 0.325 1.95 0.86666 0.43333-0.54166 1.1917-0.86666 1.95-0.86666 1.3 0 2.3833 0.975 2.3833 2.3833 0 1.625-1.5167 2.925-3.6833 4.9834l-0.65 0.5416z",
  fill: "currentColor"
});

function SvgDiagnosci(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default __webpack_public_path__ + "static/2.3.2/media/diagnosci.5aa45545.svg";
export { SvgDiagnosci as ReactComponent };